export default __webpack_public_path__ + "static/media/raphael.375d9b87.svg";